<template>
    <div>

        <div v-if="getClub.myabft_user_club && getClub.myabft_user_club.length==0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <p>
                                Aucun membre n'a accès à ce club dans MyABFT
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form role="form" v-if="getClub.myabft_user_club && getClub.myabft_user_club.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">({{getClub.myabft_user_club.length}} membres possèdent un accès)</h3>
                        </div>
                        <div class="box-body">
                            <b-table
                                    id="tableListingAllUserMyABFT"
                                    responsive bordered striped hover
                                    :items="getClub.myabft_user_club"
                                    :fields="columns"
                                    :current-page="pagination_meta.current_page"
                                    :per-page="pagination_meta.per_page"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :sort-compare="sortCompareAdvanced"
                                    :no-local-sorting="true"
                                    :no-sort-reset="true"
                                    :empty-text="'Aucun résultat'"
                                    :empty-filtered-text="'Aucun résultat'"
                                    :busy.sync="isBusy"
                                    foot-clone
                                    show-empty
                            >
                                <template slot="user.membre" slot-scope="data">
                                    <router-link
                                            :to="{ name: 'Member', params: { member_id: data.item.user.my_a_b_f_t_user.member.id }}">
                                        {{data.item.user.my_a_b_f_t_user.member.fullName }}
                                    </router-link>
                                </template>

                                <template slot="read" slot-scope="data">
                                    <div v-if="!isEditing(data.item.id)">
                                        {{data.item.read==1 ? 'OUI':'NON'}}
                                    </div>
                                    <div v-if="isEditing(data.item.id)">
                                        <select v-model="getObjectEditable(data.item.id).read">
                                            <option value="1">OUI</option>
                                            <option value="0">NON</option>
                                        </select>
                                    </div>
                                </template>

                                <template slot="write" slot-scope="data">
                                    <div v-if="!isEditing(data.item.id)">
                                        {{data.item.write==1 ? 'OUI':'NON'}}
                                    </div>
                                    <div v-if="isEditing(data.item.id)">
                                        <select v-model="getObjectEditable(data.item.id).write"
                                        @change="getObjectEditable(data.item.id).write==1 ? getObjectEditable(data.item.id).read=1 : '' ">
                                            <option value="1">OUI</option>
                                            <option value="0">NON</option>
                                        </select>
                                    </div>
                                </template>

                                <template slot="actions" slot-scope="data">
                                    <button v-if="!isEditing(data.item.id)"
                                            @click.prevent="editItem(data.item.id)"
                                            class="btn btn-default padding2">
                                        <i class="glyphicon glyphicon-pencil"></i>
                                    </button>
                                    <button v-if="!isEditing(data.item.id)"
                                            @click.prevent="removeInscription(data.item.id)"
                                            class="btn btn-default padding2">
                                        <i class="glyphicon glyphicon-remove"></i>
                                    </button>
                                    <button v-if="isEditing(data.item.id)"
                                            @click.prevent="validEditing(data.item.id)"
                                            class="btn btn-primary padding2">
                                        <i class="glyphicon glyphicon-ok"></i>
                                    </button>
                                    <button v-if="isEditing(data.item.id)"
                                            @click.prevent="cancelEditing(data.item.id)"
                                            class="btn btn-danger padding2">
                                        <i class="glyphicon glyphicon-ban-circle"></i>
                                    </button>
                                </template>

                            </b-table>
                            <b-pagination size="md"
                                          :total-rows="getClub.myabft_user_club.length"
                                          v-model="pagination_meta.current_page"
                                          :per-page="pagination_meta.per_page">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                loading: {},
                dataTableRankingMember: null,
                sortBy: null,
                sortDesc: null,
                arrayEdits: [],
                isBusy: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columns: [
                    {
                        label: 'Membre',
                        key: 'user.membre',
                        sortable: true,
                    },
                    {
                        label: 'Accès en lecture',
                        key: 'read',
                        sortable: false,
                    },
                    {
                        label: 'Accès en écriture',
                        key: 'write',
                        sortable: false,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                        sortable: false,
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getClub: 'getClub',
                getRoute: 'getRoute',
            }),

        },
        mounted: function () {
            var these = this
            // this.$nextTick(function () {
            //     setTimeout(function () {
            //         these.refreshListings()
            //     }, 1000)
            // })
        },
        created() {
        },
        watch: {},
        components: {},
        methods: {
            ...mapActions({}),
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },

            removeInscription: function (idMyAbftUser) {
                this.isBusy = true
                let self = this;
                let item = _.find(this.getClub.myabft_user_club, function (item) {
                    return item.id == id;
                });
                this.$http.post(this.getRoute('removeRightForClub'),
                    {
                        id_club: self.getClub.id,
                        id_myAbftUser: idMyAbftUser,
                    })
                    .then(function (response) {
                        this.isBusy = false
                        this.disabledBtn = false
                        self.$noty.success("Modification effectuée")
                        self.getClub.myabft_user_club = response.body
                        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                            return item.id == idMyAbftUser;
                        });
                    }, (response) => {
                        this.isBusy = false
                        this.disabledBtn = false
                        self.$noty.error("Modification échouée")
                    });
            },
            validEditing: function (idMyAbftUser) {
                this.isBusy = true
                let self = this;
                let item=this.getObjectEditable(idMyAbftUser);
                this.$http.put(this.getRoute('updateRightForClub'),
                    {
                        id_club: self.getClub.id,
                        id_myAbftUser: item.id,
                        read: item.read,
                        write: item.write
                    })
                    .then(function (response) {
                        this.isBusy = false
                        this.disabledBtn = false
                        self.$noty.success("Modification effectuée")
                        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                            return item.id == idMyAbftUser;
                        });
                    }, (response) => {
                        this.isBusy = false
                        this.disabledBtn = false
                        self.$noty.error("Modification échouée")
                    });

            },
            getObjectEditable: function (id) {
                return _.find(this.arrayEdits, function (item) {
                    return item.id == id;
                })
            },

            editItem: function (id) {
                let self = this
                let item = _.find(this.getClub.myabft_user_club, function (item) {
                    return item.id == id;
                });
                let item2 = _.find(this.arrayEdits, function (item) {
                    return item.id == id;
                });
                // debugger
                if (!item2)
                    this.arrayEdits.push(item)
            },
            cancelEditing: function (id) {
                this.arrayEdits = _.reject(this.arrayEdits, function (item) {
                    return item == id;
                });
            },
            isEditing: function (id) {
                let test= _.find(this.arrayEdits, function (item) {
                    return item.id == id;
                })
                return test ? true : false
            },
            refreshListings: function () {
                // this.dataTableRankingMember = $("#rankingMember").DataTable({
                //     language: variables.dt_french(),
                //     "paging": true,
                //     "ordering": true,
                //     "info": true,
                //     "autoWidth": true,
                // });
            },
            orderByPoste: function (equipe) {
                return _.sortBy(equipe, function (equipe) {
                    return equipe.poste_club.ordre
                })
            },
            groupByClub: function () {
                let groupe = _.groupBy(this.getMember.equipe_club, function (equipe) {
                    return equipe.id_club
                })
                return groupe;
            },
            // setRightForClub: function (idMyAbftUser) {
            //     Vue.$set(this.loading, idMyAbftUser, true);
            //     const self = this
            //     this.$http.post(this.getRoute('setRightForClub'),
            //         {
            //             id_club: self.getClub.id,
            //             id_myAbftUser: idMyAbftUser,
            //             read: self.rightsMyabftUsers[myabft_user_club.id] >= 1 ? true : false,
            //             write: self.rightsMyabftUsers[myabft_user_club.id] >= 2 ? true : false,
            //         })
            //         .then(function (response) {
            //             self.$noty.success("Modification effectuée")
            //             self.loading[idMyAbftUser] = false;
            //         }, (response) => {
            //             self.$noty.error("Modification échouée")
            //             self.loading[idMyAbftUser] = false
            //         });
            // },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },

        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/MyABFTClub.vue